<template>
  <div>
    <div v-if="!disabled" class="operate-btns">
      <el-button type="primary" @click="dialogOpen = true">选择</el-button>
      <el-button @click="$emit('clear')">清空</el-button>
    </div>
    <el-form v-if="subOrder" class="outer-form" label-width="110px">
      <el-form-item label="价格名称：">
        <span>{{ erpOrderName }}</span>
      </el-form-item>
      <el-form-item label="ERP子单号：">
        <span>{{ subOrder }}</span>
      </el-form-item>
    </el-form>
    <div v-else-if="disabled">无</div>

    <el-dialog destroy-on-close top="5vh" width="70%" :visible.sync="dialogOpen" @opened="hendleOpened">
      <template slot="title">
        <div class="dialog-title">选择ERP订单</div>
      </template>

      <template v-if="view === 'list'">
        <el-form ref="form" class="query-form" :model="form" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="ERP子单号">
                <el-input v-model="form.subOrder" size="small" clearable @clear="handleClearSearch('subOrder')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="ERP产品编码">
                <el-input v-model="form.materialCode" size="small" clearable @clear="handleClearSearch('materialCode')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-button type="primary" size="small" @click="handleSearch">
                  <i class="el-icon el-icon-search" />查询
                </el-button>
                <el-button size="small" @click="resetForm">
                  <i class="el-icon el-icon-refresh-right" />重置
                </el-button>
            </el-col>
          </el-row>
        </el-form>
        <Table ref="table" v-loading="loading" :props="table.props" :header="table.header" :data="table.data" />
        <pagination
          backgroud
          :currentpage="pager.currentPage"
          :pagesize="pager.pageSize"
          :totalcount="pager.total"
          @handle-size-change="handleSizeChange"
          @handle-current-change="handleCurrentChange"
        ></pagination>
      </template>
      <template v-if="view === 'detail'">
        <ErpOrderDetail
          :show-log="true"
          :model="erpOrderModel"
          :space-options="spaceList"
          maxHeight="460px"
        />
        <div slot="footer" class="dialog-footer">
          <el-button @click="backToList">返回</el-button>
          <el-button type="primary" @click="handleSelect(erpOrderModel)">选择</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ErpOrderDetail from './ErpOrderDetail.vue'

export default {
  components: {
    ErpOrderDetail
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    subOrder: {
      type: String,
      default: ''
    },
    erpOrderName: {
      type: String,
      default: ''
    },
    sellingType: {
      type: Number,
      default: 0
    },
    spaceList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogOpen: false,
      form: {
        subOrder: '',
        materialCode: ''
      },
      erpOrderModel: {},
      view: 'list',
      loading: false,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark',
          'row-style': { height: '40px' },
          'cell-style': { padding: '0' },
          'height': 480,
          'max-height': 480
        },
        header: [
          {
            label: 'ERP子单号',
            prop: 'subOrder',
            'min-width': 160,
            fixed: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: '价格规则',
            prop: 'subOrderName',
            'min-width': 240,
            fixed: 'left',
            'show-overflow-tooltip': true
          },
          {
            label: 'ERP订单号',
            prop: 'orderNo',
            'min-width': 200,
            'show-overflow-tooltip': true
          },
          {
            label: 'ERP订单名称',
            prop: 'orderName',
            'min-width': 240,
            'show-overflow-tooltip': true
          },
          {
            label: '子单状态',
            prop: 'subOrderStatus',
            'min-width': 100,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return ['启用', '暂停'][row.subOrderStatus]
            }
          },
          {
            label: '客户',
            prop: 'agentName',
            'min-width': 240,
            'show-overflow-tooltip': true
          },
          {
            label: 'ERP产品编码',
            prop: 'materialCode',
            'min-width': 160,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.materialEntity ? row.materialEntity.materialCode : ''
            }
          },
          {
            label: 'ERP产品名称',
            prop: 'materialName',
            'min-width': 200,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return row.materialEntity ? row.materialEntity.materialName : ''
            }
          },
          {
            label: '投放时间',
            prop: 'scheduleTime',
            'min-width': 200,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return `${row.scheduleStartTime}~${row.scheduleEndTime}`
            }
          },
          {
            label: '溢价',
            prop: 'isBargain',
            'min-width': 100,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return ['否', '是'][row.isBargain]
            }
          },
          {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            align: 'center',
            width: '120',
            render: (h, { row }) => {
              return <div>
                <el-button type="text" onClick={() => this.showDetail(row)}>详情</el-button>
                <el-button type="text" onClick={() => this.handleSelect(row)}>选择</el-button>
              </div>
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    hendleOpened() {
      this.handleSearch()
    },
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pager.pageSize, this.pager.currentPage]
      const filter = {
        pageSize,
        pageNo,
        order: 'desc',
        sort: 'subOrderId',
        materialEntity: {
          sellingType: this.sellingType === 1 ? 'CPM' : 'CPD'
        },
        subOrder: this.form.subOrder ? this.form.subOrder : undefined,
        materialCode: this.form.materialCode ? this.form.materialCode : undefined
      }
      this.$service.getErpOrderPageList(filter).then(data => {
        this.loading = false
        this.table.data = data.rows || []
        this.pager.total = data.total || 0
      })
        .catch(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pager.currentPage = 1
      this.pager.pageSize = 10
      this.fetchData()
    },
    handleClearSearch(field) {
      this.form[field] = ''
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    resetForm() {
      this.form = {
        subOrder: '',
        materialCode: ''
      }
      this.handleSearch()
    },
    showDetail(row) {
      this.loading = true
      this.$service.getErpOrderDetail({ subOrderId: row.subOrderId }).then(res => {
        this.loading = false
        this.erpOrderModel = res
        this.view = 'detail'
      })
        .catch(() => {
          this.loading = false
        })
    },
    handleSelect(rowData) {
      this.$emit('data-select', rowData)
      this.dialogOpen = false
    },
    backToList() {
      this.erpOrderModel = {}
      this.view = 'list'
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .el-dialog__body
  padding 0 20px 0 30px
.el-input >>> .el-input-group__append
  background-color #fff
  &:hover, &:focus
    color #FF8B00
    border-color #ffdcb3
    background-color #fff3e6
.dialog-title
  font-weight 700
  border-bottom 1px solid #eee
.query-form
  margin 15px 0
  .el-col
    padding-left 10px
>>>.el-table__fixed-right
  .el-table__fixed-header-wrapper th
    border-left 1px solid #EBEEF5
  .el-table__fixed-body-wrapper
    border-right 1px solid #EBEEF5
    width 118px
.dialog-footer
  padding-bottom 10px
  text-align center
  .el-button+.el-button
    margin-left 80px
.el-icon-circle-close
  display none
  padding-right 6px
  line-height 36px
  font-size 16px
  cursor pointer
  &:hover
    color #ff8b00
.outer-form
  margin 10px 0
  padding 10px 12px
  width 50%
</style>
